import { ca } from '@cian/analytics';

import { IAgentSchema, IOfferSchema, IUserSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { IRosreestrInfo } from '../../types/offerData';
import { getIsCommercialByOffer } from '../../utils/getIsCommercialByOffer';
import { getCustomUrl } from '../../utils/tracking/getCustomUrl';
import { getPage } from '../../utils/tracking/getPage';
import { getPartner } from '../../utils/tracking/getPartner';
import { getProduct } from '../../utils/tracking/getProduct';
import { getUser } from '../../utils/tracking/getUser';
import { getProducts } from '../../utils/tracking/get_products';

export type TRealtorLabel = 'to_realtorCard_name' | 'to_realtorCard_qty' | 'to_realtorCard_ava';

export type TBuilderLabel =
  | 'to_developerCard_name'
  | 'to_developerCard_ready_JK'
  | 'to_developerCard_in_progress_JK'
  | 'to_developerCard_more';

interface ITrackShowPhoneClick {
  offer: IOfferSchema;
  agent: IAgentSchema | null;
  abGroup: number;
  user: IUserSchema | null;
  kpId: number | null;
  isBot?: boolean;
  rosreestrInfo: IRosreestrInfo | null;
}

export function trackClickShowPhone({ offer, agent, abGroup, user, kpId, isBot, rosreestrInfo }: ITrackShowPhoneClick) {
  const products = getProducts({ agent, offer, kpId, rosreestrInfo });

  const isNeedToEnrichEvent = getIsCommercialByOffer(offer);
  const eventMethod = isNeedToEnrichEvent ? 'eventEnrich' : 'eventSite';

  ca(eventMethod, {
    action: `Open_card_agent_block${isBot ? '_bot' : ''}`,
    category: 'Phones',
    label: getCustomUrl(offer, agent),
    name: 'oldevent',
    ...(isNeedToEnrichEvent && { event: 'oldevent' }),
    page: {
      ...getPage(agent, offer),
      ...(isNeedToEnrichEvent && { offerType: 'offer' }),
    },
    partner: getPartner(user, offer),
    products: [
      {
        ...products,
        variant: products.variant ? products.variant.split('/') : [],
      },
    ],
    user: getUser(user, abGroup),
  });
}

/* istanbul ignore next */
export function trackClickShowPhoneGallery(
  offer: IOfferSchema,
  agent: IAgentSchema | null,
  abGroup: number,
  user: IUserSchema | null,
  kpId: number | null,
) {
  const products = getProducts({ agent, offer, kpId });

  ca('eventSite', {
    action: `Open_photo_overlay`,
    category: 'Phones',
    label: getCustomUrl(offer, agent),
    name: 'oldevent',
    page: getPage(agent, offer),
    partner: getPartner(user, offer),
    products: [{ ...products, variant: products.variant ? products.variant.split('/') : [] }],
    user: getUser(user, abGroup),
  });
}

/* istanbul ignore next */
export function trackClickBuilder(label: TBuilderLabel) {
  ca('event', {
    action: 'to_developerCard_agent_block',
    category: 'card',
    label,
    name: 'oldevent',
  });
}

/* istanbul ignore next */
export function trackGoToCard(label: string) {
  ca('event', {
    action: 'to_realtorCard_agent_block',
    category: 'card',
    label,
    name: 'oldevent',
  });
}

/* istanbul ignore next */
export function trackFirstMessageClick(offer: IOfferSchema, agent: IAgentSchema | null) {
  const products = getProduct(offer, agent);

  ca('event', {
    action: 'send_message',
    category: 'card',
    label: getCustomUrl(offer, agent),
    name: 'oldevent',
    products: [{ ...products, variant: products.variant ? products.variant.split('/') : [] }],
  });
}
